var map = {
	"./G.png": 14266,
	"./aletia.png": 45815,
	"./ali.png": 33731,
	"./ali2.png": 13401,
	"./ali3.png": 81446,
	"./eric.png": 9681,
	"./ian.png": 63936,
	"./kitty4.png": 34731,
	"./spila.png": 80224,
	"./tasos.png": 73324,
	"./tony.png": 60083,
	"./waseem.png": 18564
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 68189;